import {
  ClipboardList,
  FileCheck2,
  LayoutDashboard,
  ListOrdered,
  PlusCircle,
  SlidersHorizontal,
  UploadCloud,
} from "lucide-react";
import type { ReactNode } from "react";

const navItems = [
  { path: "/", label: "Dashboard", icon: LayoutDashboard },
  { path: "/orders", label: "Orders", icon: ListOrdered },
  { path: "/add", label: "Add Order", icon: PlusCircle },
  { path: "/upload", label: "Upload Screenshot", icon: UploadCloud },
  { path: "/review", label: "Review OCR", icon: FileCheck2 },
  { path: "/rules", label: "Product Rules", icon: SlidersHorizontal },
];

interface LayoutProps {
  route: string;
  children: ReactNode;
}

export function Layout({ route, children }: LayoutProps) {
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <a className="brand" href="#/">
          <ClipboardList size={24} aria-hidden />
          <span>订单统计</span>
        </a>
        <nav className="nav-list" aria-label="主导航">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = item.path === route;

            return (
              <a
                className={active ? "nav-link active" : "nav-link"}
                href={`#${item.path}`}
                key={item.path}
              >
                <Icon size={18} aria-hidden />
                <span>{item.label}</span>
              </a>
            );
          })}
        </nav>
      </aside>
      <main className="content">{children}</main>
    </div>
  );
}
